import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';

@Injectable()
export class ProfileService {

  constructor(public http:HttpClient) { }
  
   change_password(server,obj){
    return this.http.post(server+"/change_password",obj); 
  }

}
 